import React, { useState } from 'react';
import Modal from '../../shared/modal';
import Input from '../../shared/input';
import SelectCheckbox from '../../shared/select-checkbox';
import Button from '../../shared/button';
import { useAppDispatch } from '../../app/hooks';
import { tryToCreateNewUser } from '../../store/brokers/partners/teams/teamsSlice';
import Error from '../../shared/error';


const userRoles = [
    { label: 'Admin', value: 'admins' },
    { label: 'Staff', value: 'staff' },
]

interface INewUserModal {
    openModal: boolean;
    handleCloseModal: () => void;
    onAddNewSuccessfully: () => void;
}

const NewUserModal = ({
    openModal,
    handleCloseModal,
    onAddNewSuccessfully,
}: INewUserModal) => {
    const dispatch = useAppDispatch();
    const [email, setEmail] = useState<any>();
    const [username, setUsername] = useState<any>();
    const [role, setRole] = useState<any>();
    const [submitError, setSubmitError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false)

    const onCloseModal = () => {
        setEmail(undefined)
        setUsername(undefined)
        setRole(undefined)
        setLoading(false)
        setSubmitError(undefined)
        handleCloseModal();
    }

    const onChangeItem = (value: any, type?: string) => {
        if (type) {
            switch (type) {
                case 'email':
                    setEmail(value)
                    break;
                case 'username':
                    setUsername(value)
                    break;
                case 'role':
                    setRole(value?.value)
                    break;
            }
        }
    }

    const onSubmit = async () => {
        if (!username || !role || !email) {
            setSubmitError('All the fields are mandatory')
            return;
        }
        setSubmitError(undefined)
        setLoading(true)
        try {
            const data = {
                username,
                role,
                email
            }
            await dispatch(tryToCreateNewUser(data)).unwrap()
            onAddNewSuccessfully()
            onCloseModal()
        } catch (err) {
            setSubmitError(`${err}`)
        }
        setLoading(false)
    }


    return (
        <Modal
            open={openModal}
            title='Add New User'
            onClose={onCloseModal}
            contentContainerStyle={'!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'}>
            <div className={'p-2 max-w-[95vw] md:min-w-[70%] lg:min-w-[60%]'}>
                <Input
                    label='Email'
                    placeholder=''
                    showValue={true}
                    inputStyle='!rounded-md'
                    labelStyle='!text-black !text-sm'
                    containerStyle='!mb-0'
                    inputUniqueName='email'
                    inputValue={email || undefined}
                    onChangeInput={onChangeItem}
                />
                <Input
                    label='Username'
                    placeholder=''
                    showValue={true}
                    inputStyle='!rounded-md'
                    labelStyle='!text-black !text-sm'
                    containerStyle='!mb-0'
                    inputUniqueName='username'
                    inputValue={username || undefined}
                    onChangeInput={onChangeItem}
                />
                <SelectCheckbox
                    name='User Role'
                    options={userRoles}
                    selectedOption={role ? userRoles?.find((item: any) => item?.value === role) : undefined}
                    uniqueName='role'
                    onChangeSelectedOption={onChangeItem}
                />
                {submitError && <Error text={submitError} />}
                <div className='my-4 flex flex-row justify-center items-center'>
                    <Button
                        label={loading ? 'Saving...' : 'Submit'}
                        className={`btn-primary-rounded-less ${loading ? '!cursor-not-allowed !opacity-60' : ''}`}
                        onClickButton={() => !loading && onSubmit()}
                    />
                </div>
            </div>
        </Modal >
    )
}
export default NewUserModal;